// extracted by mini-css-extract-plugin
export default {"link":"CaseSummaryItem_link__M-84t","linkIcon":"CaseSummaryItem_linkIcon__wbv65","placeholder":"CaseSummaryItem_placeholder__U4Khg"};